import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
      setLoading(false);
    };
    checkUser();
  }, []);

  console.log('ProtectedRoute: Rendering with user:', user);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner
  }

  if (!user) {
    // Get the current URL including query parameters
    const currentPath = window.location.pathname;
    const queryParams = window.location.search;
    const redirectUrl = encodeURIComponent(`${currentPath}${queryParams}`);
    
    return <Navigate to={`/auth?redirect=${redirectUrl}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
